<template>
    <div class="showIndexWrap">
        <div class="searchBar fr ac jsb">
            <div @click="goCityList" class="location fr ac">
                <img src="../../../static/imgs/movie/down.png" alt />
                <span>{{selectedCity}}</span>
            </div>
            <img src="../../../static/imgs/movie/search.png" alt class="searchIcon" />
        </div>
        <div class="scrollBar fr ac">
            <div :class="activeIdx == index ? 'scrollItem active' : 'scrollItem'" @click="switchCategory(index, item.id)" v-for="(item, index) in categoryList" :key="index">{{item.name}}</div>
        </div>
        <div class="showList fc ac" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0">
            <div class="showItem fr ac" v-for="(item, index) in showList" :key="index" @click="viewDetail(item.id)">
                <img class="showImg" :src="item.logo" alt />
                <div class="showInfo fc jsb">
                    <h3>{{item.name}}</h3>
                    <span
                        v-show="item.startdate && item.enddate"
                    >{{item.startdate}} ~ {{item.enddate}}</span>
                    <span class="address" v-show="item.venue">{{item.venue}}</span>
                    <span></span>
                    <div class="fr ac jsb">
                        <span class="status">{{item.status}}</span>
                        <span class="price">
                            <strong>200</strong>元起
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedCity: this.getLocal("selectedCity")
                ? this.getLocal("selectedCity")
                : this.getLocal("currentCity")
                ? this.getLocal("currentCity")
                : "上海",
            citycode: this.getLocal("selectedCityCode")
                ? this.getLocal("selectedCityCode")
                : this.getLocal("currentCityCode")
                ? this.getLocal("currentCityCode")
                : "310100",
            categoryList: [],
            cateid: "",
            showList: [],
            activeIdx: 0,
            page_no: 0
        };
    },
    watch: {
        citycode(val, oldVal) {
            this.page_no = 0;
            this.showList = [];
            this.getShowList();
        },
        cateid(val, oldVal) {
            this.page_no = 0;
            this.showList = [];
            this.getShowList();
        }
    },
    components: {},
    created() {
        this.getCategoryList();
    },
    methods: {
        // 城市列表
        goCityList() {
            this.$router.push("/cityList");
        },
        getCategoryList() {
            this.$post({
                method: "drama.category.list"
            }).then(res => {
                if (res.success) {
                    this.categoryList = res.data.categorylist;
                    if (res.data.categorylist.length) {
                        this.cateid = res.data.categorylist[0].id;
                        this.getShowList();
                    }
                }
            });
        },
        getShowList() {
            this.$post({
                method: "drama.list",
                citycode: this.citycode,
                cateid: this.cateid,
                page_no: this.page_no
            }).then(res => {
                if (res.success) {
                    this.showList = this.showList.concat(res.data.dramalist);
                }
            });
        }, 
        switchCategory(idx, id){
            this.activeIdx = idx
            this.cateid = id
            this.page_no = 1;
            this.showList = [];
            this.getShowList();
        },
        // 加载更多
        loadMore() {
            if (this.$route.path == "/showIndex") {
                this.page_no++;
                this.getShowList();
            }
        },
        viewDetail(id){
            this.$router.push({path: "/showDetail", query: {did: id}})
        }
    }
};
</script>
<style lang="scss">
@import "../../../static/css/base";
.showIndexWrap {
    .searchBar {
        width: 100%;
        height: 100px;
        background-color: #fff;
        padding: 0 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #c8c7cc; /* no */
        position: fixed;
        top: 0;
        z-index: 10;
        .location {
            span {
                font-size: 32px;
                color: $themeColor;
            }
            img {
                width: 24px;
                height: 20px;
                margin-right: 10px;
            }
        }
        .searchIcon {
            width: 42px;
            height: 42px;
            margin-right: 10px;
        }
    }
    .scrollBar {
        position: fixed;
        top: 100px;
        width: 100%;
        height: 88px;
        overflow-x: scroll;
        white-space: nowrap;
        background: #fff;
        border-bottom: 1px solid #c8c7cc; /* no */
        .scrollItem {
            display: inline-block;
            padding: 0 30px;
            height: 70px;
            line-height: 70px;
            font-size: 30px;
            position: relative;
        }
        .scrollItem:first-of-type {
            padding-left: 40px;
        }
        .scrollItem:last-of-type {
            padding-right: 40px;
        }
        .active {
            color: $themeColor;
        }
        .active::after {
            content: "";
            position: absolute;
            width: 70px;
            height: 3px;
            background: $themeColor;
            bottom: -3px;
            left: calc(50% - 35px);
        }

}
    .scrollBar::-webkit-scrollbar {
        display: none;
    }
    .showList {
        margin-top: 190px;
        height: 100%;
        .showItem {
            width: 100%;
            height: 276px;
            box-sizing: border-box;
            padding: 30px 20px;
            background: #fff;
            border-bottom: 1px solid #c8c7cc; /* no */
            .showImg {
                width: 136px;
                height: 100%;
                margin-right: 20px;
            }
            .showInfo {
                width: calc(100% - 156px);
                height: 100%;
                h3 {
                    font-size: 32px;
                    line-height: 46px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                span {
                    font-size: 24px;
                    color: #818181;
                }
                .address {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .status {
                    height: 36px;
                    line-height: 36px;
                    color: #fff;
                    background: #11a1f7;
                    padding: 0 12px;
                    border-radius: 18px;
                }
                .price {
                    strong {
                        color: #f76746;
                        font-size: 30px;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/show/showIndex.vue